import React from 'react';

const ComposableContext = React.createContext();

export default ComposableContext;
